import React from "react";


export default function ripple(evt) {
    const element = evt.currentTarget;
    if (element.classList.contains("has-ripple-effect") || element.classList.contains("disabled"))
        return;

    const ripple = document.createElement("span"),
        rect = element.getBoundingClientRect(),
        clientX = (evt.changedTouches ? evt.changedTouches[0].clientX : evt.clientX),
        clientY = (evt.changedTouches ? evt.changedTouches[0].clientY : evt.clientY),
        radius = Math.max(rect.height, rect.width),
        left = clientX - rect.left - radius / 2,
        top = clientY - rect.top - radius / 2;

    ripple.classList.add("ripple-effect");
    ripple.style.width = ripple.style.height = radius + 'px';
    ripple.style.left = left + 'px';
    ripple.style.top = top + 'px';
    ripple.addEventListener('animationend', removeRipple);
    ripple.addEventListener('webkitAnimationEnd', removeRipple);
    setTimeout(removeRipple, 1000); // ensure the class is removed even if the animation doesn't finish (element gets hidden)

    element.classList.add("has-ripple-effect");
    element.appendChild(ripple);

    function removeRipple() {
        if (ripple && ripple.parentNode)
            ripple.parentNode.removeChild(ripple);
        if (element)
            element.classList.remove("has-ripple-effect");
    }
}

export function RippleButton(props) {
    return <button type="button" onMouseDown={ripple} onTouchStart={ripple} {...props}></button>;
}